import React, { useState, useEffect, useReducer, useContext } from 'react';
import { useForm } from 'react-hook-form';
import Eligibility from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/Eligibility';
import EmploymentSts from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/EmploymentSts';
import IncomeProof from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/IncomeProof';
import FinancialSitn from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/FinancialSitn';
import MonthlyIncome from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/MonthlyIncome';
import MonthlyIncomeVariation from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/MonthlyIncomeVariation';
import ChangeDescription from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/ChangeDescription';
import EssentialBills from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/EssentialBills';
import AnyApply from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/AnyApply';
import IncomeReviewed from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/IncomeReviewed';
import MoreCredit from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/MoreCredit';
import CreditLimitIncrease from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/CreditLimitIncrease';
import FollowingApply from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/FollowingApply';
import FianancialStrain from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/FianancialStrain';
import PleaseDescribe from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/PleaseDescribe';
import LenderSupport from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/LenderSupport';
import '../../../assets/QuestionniareNewFLP/questionnaire.scss';
import '../../../assets/QuestionniareNewFLP/custom.scss';
import VisitorParamsContext from "../../../Contexts/VisitorParams";
import QueryStringContext from "../../../Contexts/QueryString";

import { useQuestionnaire } from '../../../Hooks/useQuestionnaire';
import { useFollowupUserQuestions } from '../../../Hooks/useFollowupUserQuestions';
import { QuestionTitleCarLoan, AnswersCarLoan, VulnerabilityOptionsCarLoan, HealthConditionOptionsCarLoan, ReEngageEmployeeStatusCarLoan, HowManyNumbers, ExpenseReengageCarLoan } from '../../../Constants/Constants';
import SpendingMore from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/SpendingMore';
import HowMany from '../../Includes/Layouts/ReEnganedCarLoanFLPQuestions/HowMany';

// Step key to component mapping
const stepComponentMap = {
  '143': Eligibility,
  '144': EmploymentSts,
  '145': IncomeProof,
  '146': FinancialSitn,
  '147': MonthlyIncome,
  '148': EssentialBills,
  '149': AnyApply,
  '150': IncomeReviewed,
  '151': MoreCredit,
  '152': HowMany,
  // '153': CreditLimitIncrease,
  '154': SpendingMore,
  '155': LenderSupport,
  '156': FollowingApply,
  '157': FianancialStrain,
  '158': PleaseDescribe,
};

// const defaultSteps = [
//   '143',
//   '144',
//   '145',
//   '146',
//   '147',
//   '148',
//   '149',
//   '150',
//   '151',
//   '152',
//   '153',
//   '154',
//   '155',
//   '156',
//   '157',
//   '158',
// ];

// Reducer logic for managing slides and answers
const initialState = {
  currentQuestionIndex: 0,
  answeredQuestions: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'ANSWER_QUESTION':
      return {
        ...state,
        answeredQuestions: {
          ...state.answeredQuestions,
          [action.stepKey]: action.answer,
        },
      };
    case 'NEXT_QUESTION':
      return {
        ...state,
        currentQuestionIndex: state.currentQuestionIndex + 1,
      };
    case 'GOTO_QUESTION':
      return {
        ...state,
        currentQuestionIndex: action.index,
      };
    case 'RESET_STATE':
      return { ...initialState, currentQuestionIndex: 0 };
    default:
      return state;
  }
};

const QuestionnaireCarLoanReEngagedFLP = ({ pendingQuestions, pageStatus, userDetails, followupData, removeFromPending }) => {
  const [steps, setSteps] = useState(pendingQuestions);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isLoading, setIsLoading] = useState(false);
  const { saveFollowupUserQuestions } = useFollowupUserQuestions();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const { queryString } = useContext(QueryStringContext);
  let hpPreviewData = JSON.parse(localStorage.getItem("hp_preview_data"));
  const questionData = [];
  const MeritPreviewData = [];
  console.log("pendingQuestions", pendingQuestions);


  const {
    register, errors, trigger, setError, clearErrors, getValues
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {},
    resolver: undefined,
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  useEffect(() => {
    if (pendingQuestions && Array.isArray(pendingQuestions)) {
      setSteps(pendingQuestions);
      dispatch({ type: 'RESET_STATE' });
    }
  }, [pendingQuestions]);

  useEffect(() => {
    (async () => {
      await pageStatus({
        uuid: userDetails.uuid,
        page_name: "re_engage_hp_question",
        status: "visited",
        source: userDetails.followup_data?.atp_sub6,
        re_engaged_id: userDetails.re_engaged_id,
      });
    })();
  }, []);

  // Function to filter steps based on answers
  const filterStepsBasedOnAnswers = (answers) => {
    
    let filteredSteps = [...(pendingQuestions)];
    
    // Check employment status answer (question 144)
    const employmentAnswer = answers[144];
    if (employmentAnswer) {
      const optionId = employmentAnswer.includes(':') ? employmentAnswer.split(':')[0] : employmentAnswer;

      // If employment status is NOT 459 or 460 (unemployed or receiving benefits), remove questions 145, 146
      if (optionId != 459 && optionId != 460) {
        filteredSteps = filteredSteps.filter(step => ![145, 146].includes(step));
      }
    }

    // Check income proof answer (question 145)
    const incomeProofAnswer = answers[145];
    if (incomeProofAnswer) {
      // If answer is 465 (No), remove question 146
      if (incomeProofAnswer == 465 || incomeProofAnswer == 465) {
        filteredSteps = filteredSteps.filter(step => step != 146);
      }
    }

    // Check monthly income variation answer (question 132)
    // const incomeVariationAnswer = answers[132];
    // if (incomeVariationAnswer) {
    //   // If answer is NOT 404 (Yes), remove question 133
    //   if (incomeVariationAnswer != 404 && incomeVariationAnswer != 404) {
    //     filteredSteps = filteredSteps.filter(step => step != 133);
    //   }
    // }

    // Check essential bills answer (question 148)
    const essentialBillsAnswer = answers[148];
    if (essentialBillsAnswer) {
      // If answer is NOT 466 (Yes), remove question 149
      if (essentialBillsAnswer != 466 && essentialBillsAnswer != 466) {
        filteredSteps = filteredSteps.filter(step => step != 149);
      }
    }

    // Check financial strain answer (question 157)
    const financialStrainAnswer = answers[157];
    if (financialStrainAnswer) {
      // If answer is NOT 512 (Yes), remove question 158
      if (financialStrainAnswer != 512 && financialStrainAnswer != 512) {
        filteredSteps = filteredSteps.filter(step => step != 158);
      }
    }

    const offeredFurtherCreditAnswer = answers[151];
    if(offeredFurtherCreditAnswer) {
      // If answer is NOT 477 (Yes), remove questions 152
      if (offeredFurtherCreditAnswer != 477) {
        filteredSteps = filteredSteps.filter(step => ![152].includes(step));
      }
    }

    console.log("Filtering steps based on answers:", answers);
    questionArray(answers);
    return filteredSteps;
  };

  const questionArray = (answers) => {
    
    // Create comprehensive answer mapping for car loan questions
    const getAnswerText = (id) => {
      return AnswersCarLoan[id] || 
             VulnerabilityOptionsCarLoan[id] || 
             HealthConditionOptionsCarLoan[id] || 
             '';
    };
    
    // Define questions that need MeritPreviewData processing for car loan
    const meritQuestions = [144, 145, 148, 150, 151, 152, 154, 155, 156, 157];
    
    // Define conditional multi-select mappings for car loan
    const conditionalMultiSelect = {
      148: 149, // If question 148 has answer 466 (Yes), include question 149 multi-select
      157: 158  // If question 157 has answer 512 (Yes), include question 158 multi-select
    };
    
    // Iterate through all answered questions
    Object.keys(answers).forEach(questId => {
      const questionId = parseInt(questId);
      const answer = answers[questId];
      
      // Get title from QuestionTitleCarLoan
      const title = QuestionTitleCarLoan[questionId] || '';
      
      let optionValue = null;
      let userInputAnswer = null;
      let optionId = null;
      
      // Handle different answer formats for questionData array
      if (Array.isArray(answer)) {
        // Multi-select answers - put everything in userInputAnswer with optionValue and optionId as null
        const optionTexts = [];
        answer.forEach(item => {
          if (typeof item === 'string' && item.includes(':')) {
            // Handle "Other" type responses like "474:Custom text" - use only the custom text, not the option label
            const [id, text] = item.split(':');
            optionTexts.push(text);
          } else if (typeof item === 'string' && !isNaN(item)) {
            // Handle numeric option IDs as strings
            const id = parseInt(item);
            optionTexts.push(getAnswerText(id));
          } else {
            // Handle numeric IDs
            optionTexts.push(getAnswerText(item));
          }
        });
        userInputAnswer = optionTexts.join(', ');
        optionValue = null;
        optionId = null;
      } else if (questionId == 147 || questionId == 146) {
        // Special handling for question 147 - monetary input
        userInputAnswer = answer;
        optionValue = null;
      } else if (typeof answer === 'string' && answer.includes(':')) {
        // Handle single "Other" type response like "463:Custom employment"
        const [id, text] = answer.split(':');
        optionValue = getAnswerText(parseInt(id));
        userInputAnswer = text;
        optionId = parseInt(id);
      } else if (typeof answer === 'string' && !isNaN(answer)) {
        // Numeric string - treat as single option ID
        const id = parseInt(answer);
        optionValue = getAnswerText(id);
        optionId = id;
      } else if (typeof answer === 'string') {
        // Pure text string - treat as user input
        userInputAnswer = answer;
        optionValue = null;
      } else {
        // Other types (numbers, etc.) - treat as option ID
        optionValue = getAnswerText(answer);
        optionId = answer;
      }
      
      // Create the question data object
      const questionDataItem = {
        title: title,
        optionValue: optionValue,
        userInputAnswer: userInputAnswer,
        questId: questionId,
        optionId: optionId
      };
      
      questionData.push(questionDataItem);
    });
    
    // Process MeritPreviewData for specific car loan questions
    meritQuestions.forEach(questionId => {
      if (answers[questionId]) {
        const answer = answers[questionId];
        
        // Check if this question has conditional multi-select
        const multiSelectQuestionId = conditionalMultiSelect[questionId];
        
        if (multiSelectQuestionId && answers[multiSelectQuestionId]) {
          // Handle conditional multi-select case
          let triggerOptionId = null;
          
          // Get the option ID that triggers the multi-select
          if (typeof answer === 'string' && answer.includes(':')) {
            triggerOptionId = parseInt(answer.split(':')[0]);
          } else if (typeof answer === 'string' && !isNaN(answer)) {
            triggerOptionId = parseInt(answer);
          } else if (typeof answer === 'number') {
            triggerOptionId = answer;
          }
          
          // Check if the trigger condition is met
          const shouldIncludeMultiSelect = 
            (questionId == 148 && triggerOptionId == 466) || // Question 148 answered "Yes" (466)
            (questionId == 157 && triggerOptionId == 512);   // Question 157 answered "Yes" (512)
          
          if (shouldIncludeMultiSelect) {
            // Format multi-select answer from the next question
            const multiSelectAnswer = answers[multiSelectQuestionId];
            let formattedValue = '';
            
            if (Array.isArray(multiSelectAnswer)) {
              const optionTexts = [];
              multiSelectAnswer.forEach(item => {
                if (typeof item === 'string' && item.includes(':')) {
                  // Handle "Other" type responses - use only the custom text
                  const [id, text] = item.split(':');
                  optionTexts.push(text);
                } else if (typeof item === 'string' && !isNaN(item)) {
                  const id = parseInt(item);
                  optionTexts.push(getAnswerText(id));
                } else {
                  optionTexts.push(getAnswerText(item));
                }
              });
              formattedValue = optionTexts.join(', ');
            }
            
            // Only push when we have the multi-select answer, not the trigger answer
            MeritPreviewData.push({
              id: triggerOptionId,
              value: formattedValue
            });
          }
          // If condition is not met, we don't push anything for conditional questions
        } else if (conditionalMultiSelect[questionId]) {
          // This is a conditional trigger question (148 or 157) but the multi-select hasn't been answered yet
          // Don't push anything yet, wait for the multi-select answer
        } else {
          // Normal single answer case
          let meritValue = '';
          let meritId = null;
          
          // Special handling for question 156 - multi-select question
          if (questionId == 156 && Array.isArray(answer)) {
            const optionTexts = [];
            answer.forEach(item => {
              if (typeof item === 'string' && item.includes(':')) {
                // Handle "Other" type responses - use only the custom text
                const [id, text] = item.split(':');
                optionTexts.push(text);
              } else if (typeof item === 'string' && !isNaN(item)) {
                const id = parseInt(item);
                optionTexts.push(getAnswerText(id));
              } else {
                optionTexts.push(getAnswerText(item));
              }
            });
            meritId = 156;
            meritValue = optionTexts.join(', ');
          } else if (typeof answer === 'string' && answer.includes(':')) {
            const [id, text] = answer.split(':');
            meritId = parseInt(id);
            meritValue = text; // Use custom text for "Other" responses
          } else if (typeof answer === 'string' && !isNaN(answer)) {
            meritId = parseInt(answer);
            meritValue = getAnswerText(meritId);
          } else {
            meritId = answer;
            meritValue = getAnswerText(answer);
          }
          
          MeritPreviewData.push({
            id: meritId,
            value: meritValue
          });
        }
      }
    });
   
  };
  
  const progress = Math.round((state.currentQuestionIndex / (steps.length - 1)) * 100);

  // Function to scroll to a specific question
  const scrollToQuestion = (stepIndex) => {
    const targetElement = document.getElementById(`step-${stepIndex + 1}`);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  };

  // Handler for answering a question and moving to next
  const handleAnswerAndNext = async (stepKey, answer) => {
    console.log('Answering question:', stepKey, 'with answer:', answer);

    setIsLoading(true);

    // Create question data object
    const question_data = {
      question_id: stepKey,
      option_id: null,
      answer_text: null,
      input_answer: null,
    };

    // Determine if answer is purely text or contains option IDs
    if (Array.isArray(answer)) {
      // Handle multi-select answers - convert to new format and assign to input_answer
      const formattedAnswers = [];

      answer.forEach(item => {
        if (typeof item === 'string' && item.includes(':')) {
          // Handle "Other" type responses like "414:Custom text"
          const [optionId, text] = item.split(':');
          formattedAnswers.push({ id: parseInt(optionId), value: text });
        } else if (typeof item === 'string' && !isNaN(item)) {
          // Handle numeric option IDs
          formattedAnswers.push({ id: parseInt(item) });
        } else {
          // Handle numeric IDs
          formattedAnswers.push({ id: item });
        }
      });

      question_data.input_answer = formattedAnswers;
    } else if (stepKey == 147) {
      // Special handling for question 147 - add pound symbol and put in input_answer
      question_data.input_answer = `£${answer}`;
    } else if (stepKey == 144 && typeof answer === 'string' && answer.includes(':')) {
      // Special handling for question 144 (EmploymentSts) - single select with "Other" option
      const [optionId, text] = answer.split(':');
      question_data.option_id = parseInt(optionId);
      question_data.input_answer = text;
    } else if (typeof answer === 'string' && answer.includes(':')) {
      // Handle single "Other" type response like "401:Custom employment" for other questions
      const [optionId, text] = answer.split(':');
      question_data.input_answer = [{ id: parseInt(optionId), value: text }];
    } else if (typeof answer === 'string' && !isNaN(answer)) {
      // Numeric string - treat as single option ID
       if(stepKey == 146) {
        question_data.input_answer = answer;
      } else {
        question_data.option_id = parseInt(answer);
      }
    } else if (typeof answer === 'string') {
      // Pure text string - treat as input answer
      question_data.input_answer = answer;
    } else {
      // Other types (numbers, etc.) - treat as option ID
      question_data.option_id = answer;
    }
    try {
      console.log('Saving question data:', question_data);

      // TODO: Uncomment and implement the actual API call

      // const response = await SaveQuestionnaire(
      //   visitorParameters.visitor_parameters,
      //   question_data,
      //   "re_engaged_followup_question_store",
      //   visitorParameters.data,
      //   queryString,
      //   followupData
      // );
      const response = await saveFollowupUserQuestions(
        question_data,
        followupData,
        "re_engaged_followup_question_store"
      );


      // Simulate API call for now
      await new Promise(resolve => setTimeout(resolve, 100));

      // Only proceed to next question if save was successful
      dispatch({ type: 'ANSWER_QUESTION', stepKey, answer });

      // Update steps based on current answers after this answer is recorded
      const updatedAnswers = { ...state.answeredQuestions, [stepKey]: answer };
      const newSteps = filterStepsBasedOnAnswers(updatedAnswers);

      // If steps changed, update them and adjust current index
      if (JSON.stringify(newSteps) !== JSON.stringify(steps)) {
        setSteps(newSteps);

        // Find the current step in the new filtered steps
        const currentStepInNewSteps = newSteps.indexOf(stepKey);
        if (currentStepInNewSteps !== -1 && currentStepInNewSteps < newSteps.length - 1) {
          const nextIndex = currentStepInNewSteps + 1;
          dispatch({ type: 'GOTO_QUESTION', index: nextIndex });
          // Scroll to next question after a brief delay to allow state update
          setTimeout(() => scrollToQuestion(nextIndex), 300);
        } else if (currentStepInNewSteps === newSteps.length - 1) {
          handleFinish();
        }
      } else {
        // Normal progression
        if (state.currentQuestionIndex < steps.length - 1) {
          const nextIndex = state.currentQuestionIndex + 1;
          dispatch({ type: 'NEXT_QUESTION' });
          // Scroll to next question after a brief delay to allow state update
          setTimeout(() => scrollToQuestion(nextIndex), 300);
        } else {
          handleFinish();
        }
      }

    } catch (error) {
      console.error('Error saving questionnaire data:', error);
      // You could show an error message to the user here
      // For now, we'll still proceed but log the error
      dispatch({ type: 'ANSWER_QUESTION', stepKey, answer });

      if (state.currentQuestionIndex < steps.length - 1) {
        const nextIndex = state.currentQuestionIndex + 1;
        dispatch({ type: 'NEXT_QUESTION' });
        // Scroll to next question after a brief delay to allow state update
        setTimeout(() => scrollToQuestion(nextIndex), 300);
      } else {
        handleFinish();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoTo = (idx) => {
    if (idx >= 0 && idx < steps.length) {
      dispatch({ type: 'GOTO_QUESTION', index: idx });
      // Scroll to the target question after a brief delay to allow state update
      setTimeout(() => scrollToQuestion(idx), 300);
    }
  };

  const handleFinish = async () => {
    // Submission logic
    console.log('Questionnaire finished. Answers:', state.answeredQuestions);
    
    // Update hpPreviewData with car loan questionnaire data
    if (hpPreviewData) {
      hpPreviewData.result.questionData = [...hpPreviewData.result.questionData, ...questionData];
      hpPreviewData.result.MeritPreviewData = [...hpPreviewData.result.MeritPreviewData, ...MeritPreviewData];
    } else {
      // Initialize hpPreviewData if it doesn't exist
      hpPreviewData = {
        result: {
          questionData: [...questionData],
          MeritPreviewData: [...MeritPreviewData]
        }
      };
    }

    console.log("Car Loan questionData", questionData);
    console.log("Car Loan MeritPreviewData", MeritPreviewData);

    // Save to localStorage
    localStorage.setItem("hp_preview_data", JSON.stringify(hpPreviewData));
    removeFromPending("questionnaire");
    
    await pageStatus({
      uuid: userDetails.uuid,
      page_name: "re_engage_hp_question",
      status: "completed",
      source: userDetails.followup_data?.atp_sub6,
      re_engaged_id: userDetails.re_engaged_id,
    });
  };

  return (
    <div className="ReEngagedFLPQuestionnaire">
      <header className="qs-header">
        <div className="container">
          <div className="qs-header__top">
            <img src="assets/ReEngageFlpQuest/img/logo.png" className="qs-header__logo" alt="tmslegal" />
          </div>
          <div className="qs-header__row">
            <div className="qs-header__title">Questions</div>
            <div className="qs-header__percent">{progress}% Completed</div>
          </div>
          <div className="qs-progress">
            <div className="qs-progress__bar" style={{ width: `${progress}%` }}></div>
          </div>
          <div className="qs-trust">
            <div className="qs-trust__item">
              <i className="bi bi-shield-lock"></i>
              <span><strong>100%</strong> secure</span>
            </div>
            <div className="qs-trust__divider"></div>
            <div className="qs-trust__item">
              <i className="bi bi-alarm"></i>
              <span>Takes just <strong className="qs-text-danger">2</strong> minutes to finish</span>
            </div>
          </div>
        </div>
      </header>

      <main className="qs qs-main">
        <div className="container">
          <div className="qs-layout">
           {/*  <aside className="qs-rail" aria-hidden="true">
              <div className="qs-rail__track">
                <div className="qs-rail__fill" style={{ height: `${progress}%` }}></div>
              </div>
              <ul className="qs-rail__dots">
                {steps.map((stepKey, idx) => {
                  const isDone = typeof state.answeredQuestions[stepKey] !== 'undefined' && idx < state.currentQuestionIndex;
                  const isCurrent = idx === state.currentQuestionIndex;
                  let dotClass = 'qs-rail__dot';
                  if (isCurrent) dotClass += ' is-current';
                  else if (isDone) dotClass += ' is-done';
                  else dotClass += ' is-future';

                  // Position logic
                  const railPadding = 15, railSpread = 10 - (railPadding * 2);
                  const visibleDotsCount = steps.length;
                  const position = visibleDotsCount > 1 ? (idx / (visibleDotsCount - 1)) * railSpread : 0;
                  const topStyle = `calc(${railPadding}% + ${position}%)`;

                  console.log("Rendering dot for step:", stepKey, "at index:", idx, "isCurrent:", isCurrent, "isDone:", isDone, "topStyle:", topStyle, "length:", visibleDotsCount, steps.length);
                  

                  return (
                    <li
                      key={stepKey}
                      className={dotClass}
                      style={{ top: topStyle, cursor: 'pointer' }}
                      onClick={() => handleGoTo(idx)}
                    >
                      <span className="qs-rail__num">{idx + 1}</span>
                    </li>
                  );
                })}
              </ul>
            </aside> */}

            <div className="qs-stage">
              {steps.map((stepKey, idx) => {
                const StepComponent = stepComponentMap[stepKey];
                if (!StepComponent) return null;

                let sectionClass = "qs-card";
                if (idx === state.currentQuestionIndex) sectionClass += " is-active";
                else if (idx < state.currentQuestionIndex) sectionClass += " is-compact";

                return (
                  <section
                    key={stepKey}
                    className={sectionClass}
                    data-step={idx + 1}
                    id={`step-${idx + 1}`}
                  >
                    <StepComponent
                      isActive={idx === state.currentQuestionIndex}
                      isCompact={idx < state.currentQuestionIndex}
                      onNext={answer => handleAnswerAndNext(stepKey, answer)}
                      onGoTo={handleGoTo}
                      answers={state.answeredQuestions}
                      stepKey={stepKey}
                      stepIndex={idx}
                      register={register}
                      errors={errors}
                      trigger={trigger}
                      setError={setError}
                      clearErrors={clearErrors}
                      getValues={getValues}
                      isLoading={isLoading}
                      onFinish={handleFinish}
                    />
                  </section>
                );
              })}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default QuestionnaireCarLoanReEngagedFLP;